/** Portal display for D-Tools imports — always SGD / S$ after USD normalization. */
import { renderProposalMoney } from "@shared/rendering";

export function formatDtoolsMoney(n: number | null | undefined): string {
  return renderProposalMoney(n);
}
